import { Component, Input, Output, EventEmitter } from '@angular/core'

@Component({
  standalone: false,
  selector: 'app-btn-group',
  templateUrl: './btn-group.component.html',
  styleUrls: ['./btn-group.component.scss'],
})
export class BtnGroupComponent {
  private _options = []

  @Input()
  get options() {
    return this._options
  }
  set options(opts: any[]) {
    this._options = opts.map((opt) =>
      typeof opt === 'object' && opt !== null
        ? opt
        : { label: String(opt), value: opt },
    )
  }

  @Input() selectedValue = null

  @Output() optionSelected = new EventEmitter()

  select(opt) {
    this.optionSelected.emit(opt && opt.value)
  }
}
